/* Система Sysupdate. */
/* Функция sysupdate() создает объект oSyspudate для начала работы. */
/* Функция sysupdate(aClasses, oWorkHandler) - начало работы системы Sysupdate. */
/* В качестве параметров принимаются: */
/* aClasses - названия классов-контейнеров для: */
/* 1) Поля загрузки файла и кнопки обновить */
/* 2) Отображения имен объектов, которые будут обновляться */
/* oWorkHandler - объект-контейнер для записи данных о ходе выполнения обновления */
function sysupdate(aClasses, oWorkHandler)
{
	var oSyspudate =
	{
		oSysupdateBase: null, // базовый объект
		oSysupdateServer: null, // объект сервера
		oSysupdateClient: null, // Объект объектов
		ini: function(aClasses, oWorkHandler)
		{
			// Переменные, которые необходимы для инициализации объектов
			var sClass 		= aClasses[0], // Определили значение класса
				oInputParam = // Определяем данные для динамики загрузки файла
				{
					oInputFile: $('.'+sClass).find('input[type=file]'), // Объект поля загрузки файла
					oPrevButton: $('.'+sClass).find('.upload-zip'), // Объект кнопки, при нажатиии на которую открывается поле загрузки файла
					oFileName: $('.'+sClass).find('.upload-zip-name') // Объект для имени загруженного файла
				};


			// Инициализация основных объектов
			this.oSysupdateBase 	= sysupdateBase(this, oWorkHandler, oInputParam);
			this.oSysupdateClient 	= sysupdateClient(this.oSysupdateBase);
			this.oSysupdateServer 	= sysupdateServer(this.oSysupdateBase, this.oSysupdateClient);

			//
			//.on('click', {oBase: this.oSysupdateBase}, this.uploadFile);

			// Обновление системы при нажатии на кнопку "Обновить данные".
			$('.'+sClass).find('.sysupdate-run').on('click', {this: this, oServer: this.oSysupdateServer, sClass:sClass}, this.oSysupdateServer.updateStart);
			sClass = aClasses[1]; // Переопределили значение класса
			this.oSysupdateClient.oClient = $('.'+sClass); // Контейнер объектов
			this.oSysupdateClient.oClientFull = $('.'+sClass+'-full');
			$(window).on('keydown', this.keydown); // Перехват кнопки обновления страницы F5
		},
		keydown: function(e)
		{
			e = e || window.event;
			if( e.keyCode == 116 ) // 116 == F5
			{
				if(!confirm("Убедитесь, что все операции были завершены.\nВы уверены, что хотите перезагрузить страницу?"))
				{
					return false;
				}
			}
			return true;
		}
	};
	return oSyspudate.ini(aClasses, oWorkHandler);
}